import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function PrivateRoute({ children, allowedRoles = [] }) {
  const { currentUser, loading, isAuthorized } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  // If no user is logged in, redirect to login
  if (!currentUser) {
    return <Navigate to="/" />;
  }

  // If user is logged in but not authorized for this route, show not-authorized
  const authorized = isAuthorized(allowedRoles);
  if (!authorized) {
    return <Navigate to="/not-authorized" />;
  }

  return children;
}

export default PrivateRoute;
